import { UserDTO } from "@/shared/types/admin/user";

// GET /users devolve o nome achatado; GET /users/{username} devolve dentro de profile.
export function resolveUserFullName(user: UserDTO | null | undefined, fallback = ""): string {
    if (!user) return fallback;

    const firstName = user.firstName ?? user.profile?.firstName ?? "";
    const lastName = user.lastName ?? user.profile?.lastName ?? "";

    return `${firstName} ${lastName}`.trim() || fallback;
}

export function resolveUserPhone(user: UserDTO | null | undefined): string {
    return user?.phoneNumber || user?.profile?.phoneNumber || "-";
}
